"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "1em", height: "1em", viewBox: "0 0 16 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("defs", null,
            React.createElement("path", { id: "map-pin_svg__a", d: "M8 4.5C3.865 4.5.5 7.789.5 11.82c0 1.06.436 2.363.487 2.506.088.256.26.67.376.917l5.574 11.556c.214.44.608.701 1.058.701.45 0 .845-.26 1.059-.7l5.578-11.557c.12-.247.288-.66.38-.921.052-.144.488-1.447.488-2.507C15.5 7.785 12.14 4.5 8 4.5m5.562 9.572c-.074.22-.221.58-.312.77L8.048 25.895a.164.164 0 01-.048.07.202.202 0 01-.048-.07L2.754 14.837a9.105 9.105 0 01-.307-.765c-.018-.047-.403-1.207-.403-2.067C2.04 8.71 4.717 6.031 8 6.031c3.283 0 5.96 2.678 5.96 5.974 0 .684-.25 1.62-.398 2.067M8 9.534a2.71 2.71 0 00-2.707 2.703 2.707 2.707 0 005.414 0A2.71 2.71 0 008 9.534m0 4.556a1.849 1.849 0 010-3.696 1.849 1.849 0 010 3.696" })),
        React.createElement("clipPath", { id: "map-pin_svg__b" },
            React.createElement("use", { xlinkHref: "#map-pin_svg__a", overflow: "visible" })),
        React.createElement("g", { clipPath: "url(#map-pin_svg__b)" },
            React.createElement("defs", null,
                React.createElement("path", { id: "map-pin_svg__c", d: "M0 4h16v24H0z" })),
            React.createElement("clipPath", { id: "map-pin_svg__d" },
                React.createElement("use", { xlinkHref: "#map-pin_svg__c", overflow: "visible" })),
            React.createElement("path", { clipPath: "url(#map-pin_svg__d)", d: "M0 0h16v32H0z" }))));
};
var SvgMapPin = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgMapPin;
var templateObject_1;
